'use client';

import { useCallback, useEffect, useRef, useState } from 'react';

import { cn } from '@/lib/utils';

import { shareStore } from '@/store/share';

import { Share } from '@/models/SocialMedia';
import { ShareActive } from '@/models/States';

import IconButton from '../buttons/IconButton';
import { ShareIcon } from '../icons';

type ShareButtonsToggleProps = {
  share: Share;
  pageDescription: string;
  white?: boolean;
};

export default function ShareButtonsToggle(props: ShareButtonsToggleProps) {
  const { share, pageDescription, white = false } = props;
  const [shareButtons, setShareButtons] = useState<boolean>(false);
  const shareButtonsRef = useRef<HTMLButtonElement>(null);
  const toggleNav = shareStore(
    (store: ShareActive) => store.toggleShareNavigation,
  );
  const activeNav = shareStore((store: ShareActive) => store.navigation);
  const showShareButtons = useCallback(() => {
    const target = shareButtonsRef.current;

    if (!target) return;

    setShareButtons(!shareButtons);
  }, [shareButtons]);

  useEffect(() => {
    shareButtons !== undefined &&
      share &&
      toggleNav(shareButtons, share as Share, pageDescription);
  }, [shareButtons, share, pageDescription, toggleNav]);

  useEffect(() => {
    setShareButtons(activeNav.opened);
  }, [activeNav.opened]);

  return (
    <li className='social-media__share block'>
      <IconButton
        icon={ShareIcon}
        variant='light'
        className={cn(
          'min-h-[28px] min-w-[28px] gap-2 rounded-full p-1 transition-colors duration-150 ease-linear first-line:relative md:min-h-[46px] md:min-w-[46px] md:p-2',
          white && 'hover:bg-transparent active:bg-transparent',
        )}
        classNames={{
          icon: `md:w-6 md:h-6 w-4 h-4 ml-[2px] ${white ? 'fill-white' : 'fill-primary'}`,
        }}
        onClick={showShareButtons}
        ref={shareButtonsRef}
      >
        <span
          className={cn(
            'pointer-events-none inline-table pr-1 transition-all duration-300 ease-out',
            white ? 'text-white' : 'font-semibold text-primary',
          )}
        >
          Share
        </span>
      </IconButton>
    </li>
  );
}
